import React from "react";
import { Link } from "gatsby-plugin-intl";
const helpers = require("../../helpers");

import "../../scss/molecules/_professional.scss";

class Professional extends React.Component {
  render() {
    return (
      <div className="professional">
        <div className="professional-media">
          <img src={this.props.icon} alt={this.props.iconAlt} />
        </div>
        <div className="professional-body">
          <p className="professional-title">{this.props.title}</p>
          <p className="professional-description">{this.props.description}</p>
          {this.props.link ? (
            <Link
              to={helpers.getTrailedUrl(this.props.link)}
              className={"professional-link"}
            >
              {this.props.linkText}
            </Link>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default Professional;
